export default "__VITE_PUBLIC_ASSET__cb5d08f5__"